/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BillingRuleAllocationProportionalSpendPlatform extends models.BillingRuleAllocationGenericTargets {
    constructor() {
        super();
        this.setDiscriminator("BillingRuleAllocationProportionalSpendPlatform");
    }

    getFixupPrototypeFunction() { return BillingRuleAllocationProportionalSpendPlatform.fixupPrototype; }

    static newInstance(model: Partial<BillingRuleAllocationProportionalSpendPlatform>): BillingRuleAllocationProportionalSpendPlatform {
        let obj = Object.assign(new BillingRuleAllocationProportionalSpendPlatform(), model);
        BillingRuleAllocationProportionalSpendPlatform.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BillingRuleAllocationProportionalSpendPlatform>): BillingRuleAllocationProportionalSpendPlatform {
        if (!model) return null;
        return BillingRuleAllocationProportionalSpendPlatform.newInstance(<BillingRuleAllocationProportionalSpendPlatform> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BillingRuleAllocationProportionalSpendPlatform) {
        if (!obj) return;

        models.BillingRuleAllocationProportionalSpendPlatform.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BillingRuleAllocationProportionalSpendPlatform): boolean {
        if (models.BillingRuleAllocationGenericTargets.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BillingRuleAllocationProportionalSpendPlatform.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
